import { getFormattedDate } from "./dateTimeHelper";

const checkValidInputOfSearchIHI = values => {
  const isValidInput = {
    basicInfo: false,
    IHINumber: false,
    Medicare: false,
    // DVA: false,
    address: false
  };

  const {
    fname,
    lname,
    dob,
    gender,
    firstNameForHIService,
    lastNameForHIService
  } = values;
  const { IHINumber, medNo, refNo, un, streetName } = values;

  const emptyElementArray = checkEmptyElementInObj({
    fname: firstNameForHIService || fname,
    lname: lastNameForHIService || lname,
    dob,
    gender
  });
  if (emptyElementArray.length === 0 && dob._isValid === true) {
    isValidInput.basicInfo = true;
  }

  if (IHINumber && IHINumber.length === 16) {
    isValidInput.IHINumber = true;
  }

  let medicareNumber = medNo;
  if (medicareNumber.length > 0) {
    // remove space in medicareNumber
    medicareNumber = medicareNumber.replace(/\s+/g, "");
  }
  if (medicareNumber && refNo && medicareNumber.length === 10) {
    isValidInput.Medicare = true;
  }
  // if (DVANumber) {
  //   isValidInput.DVA = true;
  // }

  let streetNumber;
  if (un && un.includes("/")) {
    let spl = un.split("/");
    streetNumber = spl[1].trim();
  } else if (un) {
    streetNumber = un.trim();
  }
  if (streetName && streetNumber) {
    isValidInput.address = true;
  }

  return isValidInput;
};

const checkEmptyElementInObj = obj => {
  const emptyKeyArray = [];
  if (!obj || typeof obj !== "object" || Object.keys(obj).length === 0)
    return emptyKeyArray;

  const objKeyValueArray = Object.entries(obj);
  objKeyValueArray.forEach(item => {
    if (typeof item[1] === "number" || typeof item[1] === "boolean") return;
    if (!item[1] || (typeof item[1] === "object" && item[1].length === 0)) {
      return emptyKeyArray.push(item[0]);
    }
    if (typeof item[1] === "object" && Object.keys(item[1]).length === 0) {
      return emptyKeyArray.push(item[0]);
    }
    if (!item[1]) emptyKeyArray.push(item[0]);
  });

  return emptyKeyArray;
};

const searchIHICriteriaType = {
  IHINumber: "IHI_NUMBER",
  Medicare: "MEDICARE",
  // DVA: "DVA",
  address: "ADDRESS"
};

const getSearchIHIPayload = (type, values = {}) => {
  const payload = {
    firstName: values.firstNameForHIService || values.fname,
    lastName: values.lastNameForHIService || values.lname,
    DOB: getFormattedDate(values.dob) || "", // "05-05-1978"
    gender: values.gender || "" // "Male"
  };

  switch (type) {
    case searchIHICriteriaType.IHINumber:
      payload.IHINumber = values.IHINumber;
      break;

    case searchIHICriteriaType.Medicare:
      let medicareNumber = values.medNo || "";
      if (medicareNumber.length > 0) {
        // remove space in medicareNumber
        medicareNumber = medicareNumber.replace(/\s+/g, "");
      }
      payload.medicareNumber = medicareNumber;
      payload.medicareReferenceNumber = values.refNo || "";
      break;

    // case searchIHICriteriaType.DVA:
    //   payload.DVANumber = values.DVANumber;
    //   break;

    case searchIHICriteriaType.address:
      let streetNumber;
      if (values.un && values.un.includes("/")) {
        let spl = values.un.split("/");
        streetNumber = spl[1].trim();
      } else {
        streetNumber = values.un ? values.un.trim() : "";
      }
      payload.state = values.state || "";
      payload.postcode = values.postCode || "";
      payload.suburb = values.suburb || "";
      payload.streetNumber = streetNumber || "";
      payload.streetName = values.streetName || "";
      break;

    default:
      break;
  }

  return payload;
};

const checkIsValidCheckDigit = HINum => {
  if (typeof HINum !== "string" && typeof HINum !== "number") {
    return false;
  } else if (typeof HINum === "number") {
    HINum = HINum.toString();
  }

  if (HINum.length !== 16) return false;

  const HINumDigitArr = HINum.slice(0, 15).split("");
  let sum = 0;
  HINumDigitArr.forEach((item, index) => {
    if (index % 2 === 0) {
      sum += item * 2 > 9 ? item * 2 - 9 : item * 2;
    } else {
      sum += item * 1;
    }
  });

  let checkDigit = 10 - (sum % 10);
  if (checkDigit === 10) checkDigit = 0;

  if (parseInt(HINum[15]) !== checkDigit) return false;

  return true;
};

export default {
  checkValidInputOfSearchIHI,
  searchIHICriteriaType,
  getSearchIHIPayload,
  checkIsValidCheckDigit
};
